import React from 'react';

interface ConfigureVendorsButtonProps {
  onClick: () => void;
}

export const ConfigureVendorsButton: React.FC<ConfigureVendorsButtonProps> = ({ onClick }) => {
  return (
    <button
    onClick={onClick}
    className="flex items-center border border-gray-200 rounded-md px-4 py-2 text-sm font-medium text-gray-900 bg-gray-200 hover:bg-gray-300 "
>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='mr-2'>
              <path d="M21 4H14M10 4H3M21 12H12M8 12H3M21 20H16M12 20H3M14 2V6M8 10V14M16 18V22" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
    Configure Strategic Vendors
</button>
    );
};